import ApplicationService from '../../../../Services/ApplicationService';

class SocialEmbed {
    static get toolbox() {
        return {
            title: 'Social Embed',
            icon:
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"\n' +
                '     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">\n' +
                '  <polyline points="16 18 22 12 16 6"></polyline>\n' +
                '  <polyline points="8 6 2 12 8 18"></polyline>\n' +
                '</svg>',
        };
    }

    constructor({ data, api }) {
        this.api = api;
        this.data = { url: data?.url || '' };
        this.wrapper = null;
        this.input = null;
        this.status = null;
    }

    async resolveUrl(value) {
        if (!value) return;
        this.status.textContent = 'Resolving…';
        try {
            const json = await ApplicationService.resolveSocialUrl(value);
            if (json?.url) {
                this.data.url = json.url;
                this.input.value = json.url;
                this.status.textContent = '✓ Ready';
            } else {
                this.status.textContent = '⚠ Cannot resolve URL';
            }
        } catch {
            this.status.textContent = '⚠ Error resolving URL';
        }
    }

    render() {
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('ce-social-embed');

        this.input = document.createElement('input');
        this.input.type = 'url';
        this.input.className = 'cdx-input';
        this.input.placeholder = 'Paste social post URL';
        this.input.value = this.data.url;

        this.input.addEventListener('input', () => {
            this.data.url = this.input.value.trim();
        });
        this.input.addEventListener('blur', () => {
            this.resolveUrl(this.input.value.trim());
        });

        this.status = document.createElement('div');
        this.status.className = 'ce-social-embed__status';

        this.wrapper.appendChild(this.input);
        this.wrapper.appendChild(this.status);
        return this.wrapper;
    }

    save() {
        return { url: this.input ? this.input.value.trim() : this.data.url };
    }
}

export default SocialEmbed;
